/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
import { AreaOfStudyCategory } from '../enums/area-of-study-category';
export class AreaOfStudyEntity extends Entity {
  category: AreaOfStudyCategory | null = null;
  id: string = '';
  name: string = '';
  isStem?: boolean | null = null;
  static override key = 'AreaOfStudy';
  static override schema = {};
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'AreaOfStudy' in input
    ) {
      const { AreaOfStudy: wrapped, ...rest } = input as {
        AreaOfStudy: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}